import { simpleAlert } from "components/CommonLib/CommonLib";
import Label from "components/LabelInput/Label";
import { HttpInstance } from "lib/HttpLib";
import { globalAlertOn } from "modules/actions/Alert";
import { getNavigatorPath } from "./commonUtil";

export const newPostRowAPi = async (navigate, storesDispatch, stateData) => {
  try {
    const config = {
      headers: {
        "content-type": "application/json",
      },
    };
    // const formData = new FormData();
    // formData.append("new_data", JSON.stringify(stateData));
    // console.log(stateData);
    const res = await HttpInstance.post(
      process.env.REACT_APP_BRANCH_SERVER + "/board/" + stateData.board_type,
      stateData,
      config,
    );
    if (res.data.msg) {
      simpleAlert(storesDispatch, "ERROR", res.data.msg);
    } else {
      //성공
      storesDispatch(
        globalAlertOn({
          show: true,
          titleText: "알림",
          reqConfirm: true,
          bodyText: (
            <>
              <Label labelText="추가 되었습니다." />
            </>
          ),
          onBtnOk: () => {
            navigate(getNavigatorPath(stateData));
          },
        }),
      );
    }
  } catch (err) {
    console.log(err);
    simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
  }
};

export const newPostCommentAPi = async (storesDispatch, stateData, commentState) => {
  try {
    const config = {
      headers: {
        "content-type": "application/json",
      },
    };
    // console.log(stateData);
    // const formData = new FormData();
    // formData.append("new_data", JSON.stringify(commentState));

    const res = await HttpInstance.patch(
      process.env.REACT_APP_BRANCH_SERVER +
        "/board/" +
        stateData.post_id +
        "/type/" +
        stateData.board_type +
        "/comment",
      commentState,
      config,
    );
    if (res.data.msg) {
      simpleAlert(storesDispatch, "ERROR", res.data.msg);
      return false;
    } else {
      //성공
      return true;
    }
  } catch (err) {
    console.log(err);
    simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
    return false;
  }
};
